import Phaser from 'phaser'

import GameScene from './game'
import PauseScene from './pause'
import HighscoresScene from './highscores'
import TitleScene from './title'
import HudScene from './hud'

function assets (loader) {
  loader.atlas('cars', 'textures/cars.png', 'textures/cars.json')
  loader.atlas('environ', 'textures/environ.png', 'textures/environ.json')
  loader.atlas('particles', 'textures/particles.png', 'textures/particles.json')
  loader.atlas('hud', 'textures/hud.png', 'textures/hud.json')
}

export default class LoadingScene extends Phaser.Scene {
  // loadScenes loads multiple scenes here and returns the starting scene
  static loadScenes (manager) {
    manager.add('GameScene', GameScene, false)
    manager.add('TitleScene', TitleScene, false)
    manager.add('HudScene', HudScene, false)
    manager.add('PauseScene', PauseScene, false)
    manager.add('HighscoresScene', HighscoresScene, false)

    return 'GameScene'
  }

  preload () {
    this.load.image('white', 'textures/white.png')
    this.started = false
    this.loadingFinished = false
    this.requiresDeviceRotation = false
  }

  checkDeviceOrientation () {
    // If the devices is not a desktop and is currently in portrait mode, setup a rotation hook:
    this.requiresDeviceRotation = !this.game.device.os.desktop && this.scale.orientation === Phaser.Scale.PORTRAIT && window.screen.orientation.type === Phaser.Scale.PORTRAIT
    if (this.requiresDeviceRotation) {
      this.scale.on('orientationchange', (orientation) => {
        if (this.started) {
          if (this.scale) {
            this.scale.off('orientationchange')
          }
          return
        }
        this.requiresDeviceRotation = this.scale.orientation === Phaser.Scale.PORTRAIT && window.screen.orientation.type === Phaser.Scale.PORTRAIT
        if (!this.requiresDeviceRotation && this.loadingFinished) {
          this.scale.off('orientationchange')
          this.startScenes()
        }
      })
    }
  }

  startScenes () {
    if (this.started) {
      return
    }
    this.started = true
    this.scene.start(this.initialScene)
  }

  create () {
    this.load.crossOrigin = 'anonymous'
    assets(this.load)

    this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
    this.scale.on('resize', () => {
      if (this.cameras.main) {
        this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
      }
    })

    const back = this.add.image(640, 360, 'white')
    back.setDisplaySize(500, 180)
    back.setTint(0)
    back.setRotation(0.1)

    const bar = this.add.image(640, 360, 'white')
    bar.setDisplaySize(2, 160)
    bar.setRotation(0.1)

    this.load.on('load', (file) => {
      console.log('Asset', file.key, 'loaded')
    })

    this.load.on('progress', progress => {
      bar.setDisplaySize(480 * progress, 160)
    })

    this.load.once('complete', () => {
      console.log('Loading complete')
      this.tweens.add({ targets: [back, bar], alpha: 0, duration: 100 })

      this.initialScene = LoadingScene.loadScenes(this.scene)
      this.loadingFinished = true

      this.checkDeviceOrientation()
      if (!this.requiresDeviceRotation) {
        this.startScenes()
      } else {
        this.add.text(640, 360, 'please rotate your device', { fontSize: '42pt', align: 'center' }).setOrigin(0.5)
        this.time.addEvent({
          delay: 100,
          repeat: -1,
          callback: () => {
            if (window.screen.orientation.type === Phaser.Scale.LANDSCAPE) {
              this.time.removeAllEvents()
              this.startScenes()
            }
          }
        })
      }
    })

    this.checkDeviceOrientation()
    this.load.start()
  }
}
